/**
 * The band (bar row/column) whose center is nearest to `coord`, or null when
 * `coord` sits more than `slop` outside it. Assumes `starts` is ascending.
 */
export const findNearestBandIndex = (
  starts: readonly (number | undefined)[],
  thickness: number,
  coord: number,
  slop: number = Number.POSITIVE_INFINITY
): number | null => {
  const n = starts.length;
  if (n === 0) return null;
  const centerAt = (i: number): number | undefined => {
    const start = starts[i];
    return start === undefined ? undefined : start + thickness / 2;
  };
  let lo = 0;
  let hi = n - 1;
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    const center = centerAt(mid);
    if (center === undefined || center < coord) lo = mid + 1;
    else hi = mid;
  }
  const distAt = (i: number): number => {
    const center = centerAt(i);
    return center === undefined
      ? Number.POSITIVE_INFINITY
      : Math.abs(center - coord);
  };
  const index = lo > 0 && distAt(lo - 1) <= distAt(lo) ? lo - 1 : lo;
  const start = starts[index];
  if (start === undefined) return null;
  if (coord < start - slop || coord > start + thickness + slop) return null;
  return index;
};
